import { CuratedOrganization } from "models";
import React from "react";
import { FaLocationArrow, FaHandshake } from "react-icons/fa";
import { BsFillClockFill } from "react-icons/bs";
import "./SecondaryInfo.scss";

interface PartnerSchoolSecondaryInfoProps {
  /** The alum whose details should be displayed. */
  partnerSchool: CuratedOrganization;
  /** Whether the details should be shown in a row or column. */
  direction?: "row" | "column";
}

/** Reusable component to display secondary information for an alum. */
export function PartnerSchoolSecondaryInfo({
  partnerSchool,
  direction,
}: PartnerSchoolSecondaryInfoProps): JSX.Element {
  const str = partnerSchool.location;
  const copy = str.slice(0);
  // eslint-disable-next-line
  const [first, ...rest] = copy.split(",");
  const remainder = rest.join(",").trim();
  return (
    <div className={`secondary-info d-flex flex-${direction || "row"}`}>
      {partnerSchool.location && (
        <span>
          <FaLocationArrow className="margin-right-9" size={23} color="grey" />
          {remainder}
        </span>
      )}

      {partnerSchool.organization && (
        <span>
          <FaHandshake color="grey" size={24} className="margin-less" />
          {partnerSchool.organization}
        </span>
      )}

      {partnerSchool.partnerSince && (
        <span>
          <BsFillClockFill className="margin-right" size={21} color="grey" />
          Partner Since {partnerSchool.partnerSince}
        </span>
      )}
    </div>
  );
}
